// "2026-06" -> "June 2026"; falls back to the raw value for anything that
// doesn't match the YYYY-MM shape the backend contract uses for `period`
// (including a missing/empty/malformed period).
//
// Shared by BoardReportList/BoardReportRunHistory (in-app table cells) and
// the printable A4 document (CoverPage/A4Page) so both surfaces show the
// same finance-grade "July 2026" label instead of the raw wire value.
export function formatPeriodLabel(period) {
  if (typeof period !== "string") return period || "—";
  const match = /^(\d{4})-(\d{2})$/.exec(period);
  if (!match) return period || "—";
  const date = new Date(Number(match[1]), Number(match[2]) - 1, 1);
  if (Number.isNaN(date.getTime())) return period;
  return date.toLocaleDateString(undefined, { month: "long", year: "numeric" });
}
